import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

const resources = {
    'de-DE': {
        translation: {
            common: {
                GO_BACK: 'zurück'
            },
            validation: {
                REQUIRED: 'Bitte füllen Sie dieses Feld aus.',
                INVALID_EMAIL: 'Bitte gib eine gültige E-Mail-Adresse ein.',
                MAX_LENGTH: 'Max. {{count}} Zeichen',
                PASSWORD_MISMATCH: 'Passwort stimmt nicht überein.',
                PASSWORD_STRENGTH: 'Das Passwort erfüllt nicht alle Vorgaben.',
                INVALID_LOGIN_DATA: 'Zugangsdaten nicht korrekt',
                INACTIVE_LOGIN: 'Dein Account wurde deaktiviert. Wende dich an einen Sportcast-Mitarbeiter für weitere Infos.',
                BLOCKED_LOGIN: 'Der Account wurde vorübergehend gesperrt. Ein erneuter Login ist nach 5 Minuten möglich.'
            },
            login: {
                LOGIN: 'Login',
                HEADER: 'Anmelden',
                EMAIL_USERNAME: 'E-Mail',
                USERNAME_HINT: 'Sportcast: Benutzername statt E-Mail',
                PASSWORD: 'Passwort',
                OPTION_HEADER: 'oder',
                FORGOT_PASSWORD: 'Passwort vergessen?',
                BACK_TO_LOGIN: 'Zurück zum Login',
                YOU_ARE_LOGGED_IN: 'Du bist eingeloggt.',
                LOGOUT: 'Logout'
            },
            forgotPassword: {
                TITLE: 'Passwort vergessen',
                SEND_LINK: 'Link versenden',
                INSTRUCTIONS: 'Wir senden dir eine E-Mail mit einem Link zum Zurücksetzen des Passwortes zu. Der Link ist zwölf Stunden gültig.',
                EMAIL: 'E-Mail',
                MAIL_SENT: 'Link versendet.',
                MAIL_SENT_CONFIRMATION: 'Wenn deine E-Mail-Adresse bekannt ist, erhältst du in Kürze eine E-Mail zum Zurücksetzen deines Passwortes.',
                LONG_ENOUGH: 'mindestens acht Zeichen',
                LOWER_AND_UPPER_CASE: 'Klein- und Großschreibung',
                SPECIAL_CHARACTERS: 'mindestens ein Sonderzeichen',
                SET_NEW_PASSWORD: 'Neues Passwort setzen',
                PASSWORD: 'Passwort',
                PASSWORD_REPETITION: 'Passwort wiederholen',
                OLD_PASSWORD: 'Altes Passwort',
                PASSWORD_SET: 'Passwort erfolgreich geändert.',
                PASSWORD_SET_CONFIRMATION: 'Du kannst dich nun mit deinem neuen Passwort einloggen.',
                TO_LOGIN: 'Zum Login'
            },
            Salutation: {
                MR: 'Herr',
                MRS: 'Frau',
                MX: 'Keine Anrede'
            },
            button: {
                CANCEL: 'Abbrechen',
                CONFIRM: 'Bestätigen',
                EDIT: 'Bearbeiten',
                SAVE: 'Speichern',
                SUBMIT: 'Abschicken',
                ADD: 'Hinzufügen',
                CLOSE: 'Schließen'
            },
            message: {
                SAVE_SUCCESS: 'Speichern erfolgreich',
                DELETE_SUCCESS: 'Löschen erfolgreich',
                EDIT: 'Bearbeiten',
                CANCEL: 'Abbrechen',
                DISMISS: 'Verwerfen',
                CONFIRM: 'Bestätigen',
                CHANGE: 'Ändern'
            },
            dropdown: {
                CHOOSE: 'Bitte wähle eine Option'
            },
            error: {
                NO_SESSION: 'Ihre Sitzung ist abgelaufen.',
                NO_ACCESS: 'Zugriff verweigert. [{method}: {url}] sollte für den aktuellen Benutzer nicht aufgerufen werden. Bitte melde den Fehler.',
                NOT_FOUND: 'Die angefragte Resource konnte nicht gefunden werden.',
                ERROR_CALLING_BACKEND: 'Abfrage konnte nicht bearbeitet werden [{code} - {method}: {url}]. Bitte melde den Fehler.',
                EMAIL_DOMAIN_NOT_ALLOWED: 'Internen Mitarbeitenden ist es nicht möglich, das Passwort zurückzusetzen. ' +
                    'Bitte wenden Sie sich an den Administrator.',
                REQUIRED: 'Bitte fülle dieses Feld aus.',
                REQUIRED_RADIO: 'Bitte wähle eine der Optionen aus.',
                TOKEN: 'Dein Link ist ungültig oder abgelaufen. Bitte fordere über "Passwort vergessen" einen neuen an.',
                PASSWORD: 'Das angegebene Passwort entspricht nicht den Passwortanforderungen.',
                INVALID_EMAIL: 'Bitte gib eine gültige E-Mail-Adresse ein.',
                WRONG_PASSWORD: 'Du hast dein Passwort leider falsch angegeben.'
            },
            profile: {
                TITLE: 'Kontaktdaten',
                SALUTATION: 'Anrede',
                FIRST_NAME: 'Vorname',
                LAST_NAME: 'Nachname',
                EMAIL: 'E-Mail',
                PHONE: 'Telefon',
                MOBILE: 'Mobil',
                CHANGE_PASSWORD: 'Passwort ändern',
                INTERNAL_USER_INFO: 'Die Kontodaten können nur über das Active Directory geändert werden.'
            },
            applications: {
                TITLE: 'Meine Anwendungen',
                DESCRIPTION: 'Wähle eine Anwendung aus, um fortzufahren.',
                LAUNCH: 'Starten',
                NO_APPLICATIONS: 'Keine Anwendungen verfügbar.',
                // Add friendly labels per clientId here:
                app: {
                    'dispo123456': 'Digitale Erstellung aller spieltagsrelevanten Dispositionen',
                    'report123456': 'Qualitätsmanagement entlang der Wertschöpfungskette'
                }
            },
            passwordDialog: {
                TITLE: 'Passwort ändern',
                PASSWORD: 'Passwort',
                PASSWORD_REPETITION: 'Passwort wiederholen'
            },
            header: {
                LOGOUT: 'Ausloggen',
                LOGOUT_USER: '{{user}} ausloggen',
                APPLICATIONS: 'Anwendungen',
                PROFILE: 'Profil'
            },
            AccountDeactivated: {
                DESCRIPTION: 'Dein Account wurde deaktiviert. Wende dich an einen Sportcast-Mitarbeiter für weitere Infos.'
            },
            Consent: {
                BUTTON_TEXT: 'Ok, verstanden',
                TEXT: 'Wir verwenden Cookies, damit du RePort bestmöglich nutzen kannst. Dabei schützen wir deine Privatsphäre und setzen nur ' +
                    'technisch erforderliche Cookies ein. Weitere Informationen findest du in unserer <1>Datenschutzerklärung</1>.'
            },
            footer: {
                IMPRINT: 'Impressum',
                PRIVACY_POLICY: 'Datenschutzerklärung',
                TERMS_OF_USE: 'Nutzungsbedingungen',
                LEGAL_NOTICE: 'Rechtliche Hinweise'
            },
            DataPrivacy: {
                I_ACCEPT_DATA_PRIVACY: 'Ich stimme den oben genannten Bedingungen zu',
                HAS_ACCEPTED_AT: 'Datenschutzerklärung zugestimmt am:',
                NOT_ACCEPTED_YET: 'Nicht zugestimmt'
            }
        }
    }
};

i18n.use(initReactI18next)
    .init({
        fallbackLng: 'de-DE',
        lng: 'de-DE',
        debug: false,
        resources
    });

export default i18n;
